import { BadgePercent } from "lucide-react";
import { PROMOS } from "@/data/services";
import { BookNowButton } from "@/components/site/PageLayout";

export const SeasonalPromos = () => (
  <section data-testid="seasonal-promos" className="py-20 md:py-28 border-t border-[#1c1c21]">
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="flex items-center gap-3">
        <span className="h-[2px] w-10 bg-[#EA0A0B]" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">Limited-time deals</p>
      </div>
      <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <h2 className="font-display uppercase leading-[0.95] tracking-wide text-4xl sm:text-5xl lg:text-6xl text-white">
          Seasonal <span className="text-[#EA0A0B]">Promotions</span>
        </h2>
        <p className="max-w-md text-sm text-slate-400 leading-relaxed">
          Mention the deal when you book or request a quote and we'll apply it to your appointment.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
        {PROMOS.map((p) => (
          <div
            key={p.id}
            data-testid={`promo-card-${p.id}`}
            className="bg-[#121216] border border-[#232329] p-7 hover:border-[#EA0A0B]/60 transition-colors"
          >
            <BadgePercent className="w-7 h-7 text-[#EA0A0B]" />
            <p className="mt-4 font-display uppercase text-xl tracking-wide text-white">{p.title}</p>
            <p className="mt-2 text-sm text-slate-300 leading-relaxed">{p.description}</p>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#EA0A0B]">{p.tag}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <BookNowButton to="/book" label="Book & Save" testid="promos-book-button" />
      </div>
    </div>
  </section>
);
